module.exports = __webpack_public_path__ + "static/media/schlumberger.582eab6e.png";